import { isRouteErrorResponse, Link, useRouteError } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { Box, Button, Typography } from '@/shared/ui';

/**
 * Catches thrown route/render errors. Nested under AppProviders so theme and i18n still apply.
 */
const RouteErrorPage = () => {
  const { t } = useTranslation('common');
  const error = useRouteError();
  const status = isRouteErrorResponse(error) ? error.status : null;
  const detail =
    import.meta.env.DEV && error instanceof Error
      ? error.message
      : isRouteErrorResponse(error)
        ? error.statusText
        : null;

  return (
    <Box
      sx={{
        height: '100%',
        overflow: 'auto',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        px: 2,
        py: 4,
      }}
    >
      <Box sx={{ maxWidth: 480, width: '100%', textAlign: 'center' }}>
        <ErrorOutlineIcon sx={{ fontSize: 64, color: 'error.main', mb: 2 }} />
        <Typography variant="h5" component="h1" gutterBottom>
          {status ? `${status} — ${t('routeError.title')}` : t('routeError.title')}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          {t('routeError.body')}
        </Typography>
        {detail ? (
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ mb: 3, fontFamily: 'monospace', wordBreak: 'break-word' }}
          >
            {detail}
          </Typography>
        ) : null}
        <Box sx={{ display: 'flex', gap: 1, justifyContent: 'center', flexWrap: 'wrap' }}>
          <Button variant="contained" onClick={() => window.location.reload()}>
            {t('routeError.retry')}
          </Button>
          <Button variant="outlined" component={Link} to="/">
            {t('routeError.home')}
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default RouteErrorPage;
